import React from "react";

const Loader = (props) => {
    return (
        <div className={ "loading--help " + (props?.loading ? "" : "loading--out") }>
            <div className="loading--inner">
                <div className="loading--bar">
                    <div className="loading--bar-0">
                        <div className="loading--bar-1">
                            <div className="loading--bar-2">
                                <div className="loading--bar-9"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Loader;
